module.exports = __webpack_public_path__ + "static/media/about-us-list-img-4.38988daa.jpg";